import React from 'react';
import bg1 from '../img/envision/homeservices/ai.jpg'; // Adjust the path according to your project structure
import bg2 from '../img/envision/homeservices/itinformation.jpg'; // Adjust the path according to your project structure
import bg3 from '../img/envision/homeservices/otimge.jpg'; // Adjust the path according to your project structure
import bg4 from '../img/envision/homeservices/IT RISK & GOVERNANCE-2 - Copy.jpg'; // Adjust the path according to your project structure

import bg5 from '../img/envision/homeservices/sustanbility.jpg'; // Adjust the path according to your project structure



const TwosidesCards = () => {
    return (
        <div style={{ marginTop: '10px' }}>
            <h1 style={{ textAlign: "center" }}>
                <span style={{ color: 'rgb(236 115 34)' }}> Empower diverse industries with secure </span><br />  compliant and intelligent solutions.
            </h1>

            {/* First Row */}
            <div className="two-side-cards-container data-two-sides-cards" >
                <div className="card left-card">
                    <img src={bg4} alt="Middle Image" />
                </div>

                <div className="center-content data-sustance-home">
                    <p style={{ marginTop: '10px', fontSize: "18px", fontWeight: 'bold', color: 'rgb(236 115 34)', position: 'relative' }}>
                        <span style={{
                            position: 'absolute',
                            top: '-10px', /* Adjust this value to control the distance between TM and the text */
                            left: '50%',
                            transform: 'translateX(-50%)',
                            fontSize: '10px', /* Adjust the font size of the TM */
                            marginLeft: '46px',
                            marginTop: '10px'
                        }}>
                            (™)
                        </span>
                        CRIGOT
                    </p>


                    <div className="vertical-line first-vertical-line"></div>

                    <p style={{ marginTop: '10px', fontSize: "14px" }}>
                        A Unified Control Framework Tailored For Each Industry, Integrating Standards, Compliance, Risk Assessment, and Governance To Drive Impact and Enable Transformation.
                    </p>





                </div>


                <div className="card right-card">
                    <img src={bg1} alt="Middle Image" />
                </div>
            </div>

            {/* Second Row */}
            <div className="two-side-cards-container" >

                <div className="center-content data-sustance-homes">
                    <p style={{ marginTop: '10px', fontSize: "18px", fontWeight: 'bold', color: 'rgb(236 115 34)', position: 'relative' }}>
                        <span style={{
                            position: 'absolute',
                            top: '-10px', /* Adjust this value to control the distance between TM and the text */
                            left: '50%',
                            transform: 'translateX(-50%)',
                            fontSize: '10px', /* Adjust the font size of the TM */
                            marginLeft: '46px',
                            marginTop: '10px'
                        }}>
                            (™)
                        </span>
                        CRIGOT
                    </p>


                    <div className="vertical-line"></div>

                    <p style={{ marginTop: '10px', fontSize: "14px" }}>
                        A Unified Control Framework Tailored For Each Industry, Integrating Standards, Compliance, Risk Assessment, and Governance To Drive Impact and Enable Transformation.
                    </p>





                </div>
                <div className="center-content data-sustance-home">
                    <p style={{ marginTop: '10px', fontSize: "18px", fontWeight: 'bold', color: 'rgb(236 115 34)' }}>
                        GEN AI

                    </p>

                    <div className="vertical-line second-vertical-line"></div>

                    <p style={{ marginTop: '10px', fontSize: "14px" }}>
                        Bespoke Generative AI Solutions, Redefining Intelligence for Every Industry.

                    </p>



                    {/* <a
                        href="/#"
                        style={{
                            display: 'inline-block',
                            marginTop: '15px',
                            fontSize: '16px',
                            background: '#000',
                            color: 'rgb(236 115 34)',
                            textDecoration: 'none',
                            padding: '10px 20px',
                            border: '2px solid rgb(236 115 34)',
                            borderRadius: '5px',
                            transition: 'background-color 0.3s ease',
                        }}
                        className="know-more-link"
                    >
                        Know More
                    </a> */}
                </div>

                <div className="card" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', background: '#000' }}>
                    <p style={{ fontSize: '55px', fontWeight: 'bold', color: 'rgb(236 115 34)' }}>DREBCON</p>
                </div>


                <div className="center-content data-sustance-home-it">
                    <p style={{ marginTop: '-20px', fontSize: "18px", fontWeight: 'bold', color: 'rgb(236 115 34)' }}>
                        IT TRANSFORMATION

                    </p>

                    <div className="vertical-line"></div>

                    <p style={{ marginTop: '10px', fontSize: "14px" }}>
                        Risk to Resilience: Revolutionizing IT with robust Controls, Mitigated Risk, and Generative AI driving transformed interconnected technology.
                    </p>


                 
                </div>


                <div className="center-content data-sustance-homes">
                    <p style={{ marginTop: '10px', fontSize: "18px", fontWeight: 'bold', color: 'rgb(236 115 34)' }}>
                        GEN AI

                    </p>

                    <div className="vertical-line"></div>

                    <p style={{ marginTop: '10px', fontSize: "14px" }}>
                        Bespoke Generative AI Solutions, Redefining Intelligence for Every Industry.

                    </p>



                    {/* <a
                        href="/#"
                        style={{
                            display: 'inline-block',
                            marginTop: '15px',
                            fontSize: '16px',
                            background: '#000',
                            color: 'rgb(236 115 34)',
                            textDecoration: 'none',
                            padding: '10px 20px',
                            border: '2px solid rgb(236 115 34)',
                            borderRadius: '5px',
                            transition: 'background-color 0.3s ease',
                        }}
                        className="know-more-link"
                    >
                        Know More
                    </a> */}
                </div>

            </div>
            <div className="two-side-cards-container data-two-sides-cards" >
                <div className="card right-card">
                    <img src={bg2} alt="Middle Image" />
                </div>


                

                <div className="center-content data-sustance-home-it">
                    <p style={{ marginTop: '-20px', fontSize: "18px", fontWeight: 'bold', color: 'rgb(236 115 34)' }}>
                        OT TRANSFORMATION
                    </p>

                    <div className="vertical-line"></div>

                    <p style={{ marginTop: '10px', fontSize: "14px" }}>
                        Modernizing Operational Technology: Intelligent Controls and Generative AI Powering a Seamless Transition to Interconnected, Next-Gen Systems.
                    </p>

                    {/* "Know More" Link */}
                    {/* <a
                        href="/#"
                        style={{
                            display: 'inline-block',
                            marginTop: '15px',
                            fontSize: '16px',
                            background: '#000',
                            color: 'rgb(236 115 34)',
                            textDecoration: 'none',
                            padding: '10px 20px', // Padding around the text
                            border: '2px solid rgb(236 115 34)', // 2px solid border with the desired color
                            borderRadius: '5px', // Border radius for rounded corners
                            transition: 'background-color 0.3s ease', // Optional: add smooth transition for hover
                        }}
                        className="know-more-link"
                    >
                        Know More
                    </a> */}
                </div>

                <div className="card right-card">
                    <img src={bg3} alt="Middle Image" />
                </div>
            </div>

            <div className="two-side-cards-container data-two-sides-cards" >

                <div className="center-content It-transfer-data">
                    <p style={{ marginTop: '-20px', fontSize: "18px", fontWeight: 'bold', color: 'rgb(236 115 34)' }}>
                        IT TRANSFORMATION

                    </p>

                    <div className="vertical-line"></div>

                    <p style={{ marginTop: '10px', fontSize: "14px" }}>
                        Risk to Resilience: Revolutionizing IT with robust Controls, Mitigated Risk, and Generative AI driving transformed interconnected technology.
                    </p>


                 
                </div>





                <div className="center-content data-sustance-homes">
                    <p style={{ marginTop: '-20px', fontSize: "18px", fontWeight: 'bold', color: 'rgb(236 115 34)' }}>
                        OT TRANSFORMATION
                    </p>

                    <div className="vertical-line"></div>

                    <p style={{ marginTop: '10px', fontSize: "14px" }}>
                        Modernizing Operational Technology: Intelligent Controls and Generative AI Powering a Seamless Transition to Interconnected, Next-Gen Systems.
                    </p>

                    {/* "Know More" Link */}
                    {/* <a
                        href="/#"
                        style={{
                            display: 'inline-block',
                            marginTop: '15px',
                            fontSize: '16px',
                            background: '#000',
                            color: 'rgb(236 115 34)',
                            textDecoration: 'none',
                            padding: '10px 20px', // Padding around the text
                            border: '2px solid rgb(236 115 34)', // 2px solid border with the desired color
                            borderRadius: '5px', // Border radius for rounded corners
                            transition: 'background-color 0.3s ease', // Optional: add smooth transition for hover
                        }}
                        className="know-more-link"
                    >
                        Know More
                    </a> */}
                </div>

            </div>


            <style jsx>{`
              .know-more-link:hover {
    background-color: #fff; /* Background color on hover */
    color: #fff !important; /* Change text color to white on hover */
  }
                .two-side-cards-container {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    gap: 50px;
                    padding: 20px;
                    flex-wrap: wrap; /* Allow items to wrap in smaller screens */
                }

                .card, .center-content {
                    background-size: cover;
                    background-position: center;
                    border-radius: 8px;
                    width: 303px;
                    height: 260px;
                    text-align: center;
                    color: white;
                    padding: 20px;
                }

                // .left-card {
                //     background-image: url('https://images.pexels.com/photos/991012/pexels-photo-991012.jpeg');
                // }

                // .right-card {
                //     background-image: url('https://images.pexels.com/photos/3787308/pexels-photo-3787308.jpeg');
                // }

                .center-content {
                    background-image: none;
                    color: black;
                }

                .image-card img {
                    width: 303px; /* Adjust the width as needed */
                    height: 260px; /* Adjust the height as needed */
                    object-fit: cover; /* Ensure the image fills the space correctly */
                    border-radius: 8px; /* Same as the card radius for consistency */
                }

                h2 {
                    margin-bottom: 10px;
                    font-size: 20px;
                }

                p {
                    font-size: 14px;
                }

                /* Media Query for Mobile Devices */
                @media (max-width: 768px) {
                    .two-side-cards-container {
                        flex-direction: column; /* Stack the items vertically */
                        gap: 30px; /* Reduce the space between cards */
                        align-items: flex-start; /* Align items to the left */
                    }

                    .card, .center-content {
                        width: 100%; /* Cards take full width on small screens */
                       
                    }

                    h1 {
                        font-size: 18px; /* Adjust heading size for smaller screens */
                        text-align: center; /* Center-align the heading */
                        margin-left: 0; /* Remove left margin */
                    }
                }

                .vertical-line {
                    width: 2px;
                    height: 34px; /* Adjust the height as needed */
                    background-color: #000; /* Line color */
                    margin: 0 129px; /* Adjust space between the paragraphs */
                    margin-bottom:-10px;
                }
            `}</style>
        </div>
    );
};

export default TwosidesCards;
